import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Heading from '../../components/heading/Heading';
import StepsSummaryBox from '../../components/stepsSummaryBox/StepsSummaryBox';
import AuthorizedPersons from '../../components/authorized-persons/AuthorizedPerson';
import StepBar from '../../components/steps-bar/StepsBar';

const StepOne = ( props ) => {
    let [ load, setLoad ] = useState(false);


    const dispatch = useDispatch()

    useEffect(() => {
        if ( !load ) {
            dispatch({ type: 'STEPS_CHANGE', value: 3 })
            if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
            }
            setLoad(true);
        } 
    }, [load])

    let prev = () => {
        props.history.push('/krok/2')
    }

    let next = () => {
        props.history.push('/krok/4')
    }

    return (
        <>
        <StepBar />
        <section className="form steps">
            <div className="container-step">
                <div className="row" >
                    <AuthorizedPersons prev={ () => prev() } next={ () => next() } />
                </div>
            </div>
        </section>
        </>
    )
}

export default StepOne;